import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import '../index.scss';

export default class ZenotiConfigure extends React.Component {
  constructor(props) {
    super(props);

    // const { business } = this.props;

    this.state = {
      isBrandLocation: false,
      selectedLocation:null,
      mandatoryFieldError: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount(){
    setTimeout(()=>{this.props.getBookingSoftwareLocations();},1000);
    const { softwares } = this.props;
    const { zenotiData, brand,form } = softwares;
    console.log('STATE 123', brand,form,zenotiData);
    this.setState({
      ...(zenotiData.isBrandLocation || brand && {isBrandLocation:brand? brand: zenotiData.isBrandLocation }),
      ...((zenotiData.selectedLocation || form.location_id)!==null && {selectedLocation: form.location_id ? form.location_id:zenotiData.selectedLocation}),
    });
  }
  componentWillReceiveProps(nextProps){
    if(this.props.softwares.bookingSoftwareLocations!=nextProps.softwares.bookingSoftwareLocations){
      const { softwares } = this.props;
    const { zenotiData, brand,form } = softwares;
    console.log('selectedLocation', form.location_id);
    this.setState({
      ...(zenotiData.isBrandLocation || brand && {isBrandLocation:brand? brand: zenotiData.isBrandLocation }),
      ...(zenotiData.selectedLocation || form?.location_id && {selectedLocation: form.location_id ? form.location_id:zenotiData.selectedLocation}),
    });
    }
  }
  onInputChange(event) {
    console.log('event',event.target.name, event.target.value);
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  onNextButtonClick() {
    const { isBrandLocation, selectedLocation,mandatoryFieldError } = this.state;
    const data ={isBrandLocation, selectedLocation};
    const validationResult = this.validate(data);
    console.log('data',validationResult,mandatoryFieldError, data)
    if (validationResult) {
      this.props.saveConfigureData(data);
      this.props.storeZentiData(data);
    }
  }

  validate(data) {
    console.log('data',data);
    if (!data.isBrandLocation && !data.selectedLocation) {
      this.setState({
        mandatoryFieldError: true,
      });

      return false;
    }

    this.setState({
      mandatoryFieldError: false,
    });

    return true;
  }
  sortLocationByName=(locations)=>{
    console.log('locations',locations);
    const sorted_list = locations.sort((a,b) =>a.name>b.name? 1:-1);
    console.log('locations',sorted_list);
    return sorted_list;
  }
  render() {
    const { isBrandLocation , selectedLocation, mandatoryFieldError } = this.state;
    const { softwares } = this.props;
    const {  brand,form } = softwares;
    const editable =  !brand && !form?.location_id;
    console.log('selectedLocation',selectedLocation);
    return (
      <div className="authorize-access">
        <form className="authorize-access__form">
          {mandatoryFieldError ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Please select checkbox if location is brand else select location from dropdown.
            </p>
          ) : null}

          {isBrandLocation?(
              <div className="authorize-access__form__row form-group single-line">
                <p className="form-group__heading single-line_label">Is this a brand location?</p>
                <input
                  type="checkbox"
                  name="isBrandLocation"
                  className={classnames({ 'has-error': mandatoryFieldError })}
                  value={isBrandLocation}
                  onChange={()=>this.onInputChange({target:{name:'isBrandLocation',value:!this.state.isBrandLocation}})}
                  checked={isBrandLocation}
                  disabled={!editable}/>
              </div>
          ):(
              <div className="authorize-access__form__row form-group select-software__content">
                <select className="input-software" name="selectedLocation" value={selectedLocation} onChange={this.onInputChange} disabled={!editable}>
                {!selectedLocation &&<option>Please Select Location</option>}
                {this.sortLocationByName(softwares?.bookingSoftwareLocations)?.map(location=>{
                return <option value={location.id} >{location.name}</option>
                })}
                </select>
              </div>
          )}

        </form>
        <div className="authorize-access__actions">
          <button className="btn btn--secondary btn--lg" type="button" onClick={this.props.onBack}>
            Previous
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onNextButtonClick}
            disabled={softwares.isSavingBookerAccountInfo}
          >
            {!softwares.isSavingBookerAccountInfo ? 'Next' : 'Saving...'}
          </button>
        </div>
      </div>
    );
  }
}

ZenotiConfigure.defaultProps = {
  postZenotiAccountInfo: () => {},
  onBack: () => {},
};

ZenotiConfigure.propTypes = {
  postZenotiAccountInfo: PropTypes.func,
  onBack: PropTypes.func,
  softwares: PropTypes.shape().isRequired,
};
